import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { LoggedOnUserPermissionsStore } from 'app/store/permissions.auth.store';
import { of, switchMap } from 'rxjs';

export const MfaAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const permissionStore = inject(LoggedOnUserPermissionsStore)

    // Check the authentication status
    return toObservable(computed(() => ({
            loaded: permissionStore.isLoaded(),
            isMfaVerified: permissionStore.isMfaVerified()
        })))
        .pipe(
            switchMap(({loaded, isMfaVerified}) => {
                // If the user is not authenticated...
                if (!loaded) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                if (isMfaVerified)  {
                    const redirectURL = route.queryParams['redirectURL'] || '/'
                    return of(router.parseUrl(redirectURL))
                }

                // Allow the access
                return of(true);
            })
        );
};
